// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar-section__btn[data-v-673636c5]{color:#fff!important}.navbar-section__btn .v-icon[data-v-673636c5],.navbar-section__btn .v-icon *[data-v-673636c5]{background-color:#27846d!important;color:#fff!important;min-width:40px!important;min-height:40px!important;border-radius:50%!important;font-size:20px!important;font-style:normal!important}.navbar-section__btn>span[data-v-673636c5]{color:#fff!important;padding:0 1px!important}", ""]);
// Exports
module.exports = exports;
